import { render } from "./AddOnhireComponent.vue?vue&type=template&id=61a73cc1"
import script from "./AddOnhireComponent.vue?vue&type=script&lang=js"
export * from "./AddOnhireComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__